$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    const scrollHeight = $($.attr(this, 'href')).offset().top - 100;
    $('html, body').animate({
        scrollTop: scrollHeight
    }, 500);
});

$(document).ready(function () {
  function addAnchorAriaLabel() {
    $('a').each(function (i, elem) {
      if (!$(elem).attr('aria-label') || $.trim($(elem).attr('aria-label')) === '') {
        var num = 1 + Math.floor(Math.random() * 100000);
        var href = $(elem).attr('href')
        var innertext = $.trim($(elem).text()) !== '' ? $.trim($(elem).text()).replace(/(<([^>]+)>)/ig, "") : '';
        if (innertext !== '') {
          $(elem).attr('aria-label', innertext);
        } else {
          if ($(elem).css('display') == 'none' || $(elem).css("visibility") == "hidden") {
            $(elem).attr('aria-label', 'Dynamically generated aria-label ' + num +' for hidden link - ' + href);
          } else {
            $(elem).attr('aria-label', 'Dynamically generated aria-label ' + num +' for link - ' + href);
          }
        }
      }
    })
  }
  for (var i = 0; i < 5; i++) {
    setTimeout(addAnchorAriaLabel, 2000 * i);
  }
});
